export const CERTIFICATE_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  CANCELLED: 'CANCELLED',
} as const;

export const CERTIFICATE_STATUS_COLOR: Record<string, 'success' | 'warning' | 'error' | 'default'> = {
  [CERTIFICATE_STATUS.ACTIVE]: 'success',
  [CERTIFICATE_STATUS.INACTIVE]: 'warning',
  [CERTIFICATE_STATUS.CANCELLED]: 'error',
};

export const PROCESS_STATUS_COLOR: Record<string, 'success' | 'info' | 'warning' | 'error' | 'default'> = {
  FINISHED: 'success',
  PENDING: 'warning',
  IN_PROGRESS: 'info',
  FAILED: 'error',
};

export const CERTIFICATE_TYPE_LABELS: Record<string, string> = {
  FLIGHTS_ONLY: 'Flights-Only',
  PACKAGE_SINGLE_CONTRACT: 'Package',
};
